<template>
  <div class="spinner-container">
    <p>{{ loadingMsg }}</p>
    <div class="global-spinner"></div>
  </div>
</template>

<script>
export default {
  name: 'Spinner',
  props: {
    loadingMsg: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../styles/mixins/spinners';
@import '../styles/variables';

.spinner-container {
  align-self: center;
  color: $base-gray;
  top: 40%;
}

.global-spinner {
  @include thin-spinner();
}
</style>
